<template>
<a target="_blank" :href="`/home/user?user_id=${user_id}`">{{Operators[user_id] ? Operators[user_id] : user_id}}</a>
</template>
<script>
  import { defineComponent } from 'vue'
  import { Operators} from '@/utils/macro'

  export default defineComponent({
    props: ['user_id'],
    data(){
      return {
        Operators
      }
    },
    // mounted() {},
    methods:{ },
  })
</script>